export const BOOKING_STATUS_LABELS: Record<string, string> = {
  pending: "Chờ xác nhận",
  confirmed: "Đã xác nhận",
  "checked-out": "Đã trả phòng",
  cancelled: "Đã huỷ",
}
